import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ModelAttributeConfig } from '@zipari/shared-ds-util-configuration';

@Component({
  selector: 'lib-claim-items-information-review',
  templateUrl: './claim-items-information-review.component.html',
  styleUrls: ['./claim-items-information-review.component.scss'],
})
export class ClaimItemsInformationReviewComponent {
  @Input() claimItemsInfoConfig: ModelAttributeConfig[];
  @Input() title: string;
  @Input() context;
  @Input() isEditable: boolean;
  @Output() editIconClickedValue: EventEmitter<void> = new EventEmitter<void>();

  editIconClicked() {
    this.editIconClickedValue.emit();
  }
}
